module.exports = __webpack_public_path__ + "img/fondo1.53a79422.jpg";